import React from "react";
import { TextComponent } from "../../../../../components";
import styles from "./businessInfo.module.css";
import Person from "../../../../../assets/staticImages/cplImage1.png";
import { FiEdit } from "react-icons/fi";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../../../config/roles";
import Storage from "../../../../../utills/AsyncStorage";
import { useSelector } from "react-redux";
import moment from "moment";
import { phoneFormat } from "../../../../../utills";

const BusinessInfo = () => {
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  const user = useSelector((state)=>state.AuthReducer.user);
  // console.log("USewr", user);
  let format = user?.business_info?.end_time && user?.business_info?.start_time ? moment(user?.business_info?.start_time).format('hh:mm A') + ' - ' + moment(user?.business_info?.end_time).format('hh:mm A') : '--'

  const navigate = useNavigate();
  const data = [
    {
      name: "Company Name",
      info: user?.business_info?.company_name ? user?.business_info?.company_name : '--'
    },
    {
      name: "Company Number",
      info: user?.business_info?.company_contact_no ? phoneFormat(user?.business_info?.company_contact_no) : '--'
    },
    {
      name: "Office Hours",
      info: format,
      days: ["Monday", "Tuesday", "Wednesday"],
    },
    {
      name: "Starting Price",
      info:  user?.business_info?.service_price ? '$' + user?.business_info?.service_price : '--'
      ,
    },
  ];

  const dataa = [
    {
      name: "Service Category",
      info: user?.business_info?.service_category_name ? user?.business_info?.service_category_name : "--",
    },
    {
      name: "Service Offer",
      info: user?.business_info?.service_offer ? user?.business_info?.service_offer : '--',
    },
    {
      name: "Description",
      info: user?.business_info?.description ? user?.business_info?.description : '--',
    },
  ];

  const renderItem = (item, index) => (
    <div className={styles.option_tab_view}>
      <div className={styles.option_tab}>
        <TextComponent text={item?.name} className={styles.text} />
      </div>
      <TextComponent text={item?.info} textClass={styles.textx}>
        <div>
          {item?.days &&
            user?.availability?.length > 0 && user?.availability?.map((day, i) => (
              <TextComponent text={i != user?.availability?.length - 1 ? `${day?.day}, ` : day?.day} textClass={styles.daysText} />
            ))}
        </div>
      </TextComponent>
    </div>
  );

  return (
    <div className={styles.mainCont}>
      <div className={styles.head}>
        <TextComponent
          text={"Business Information"}
          textClass={styles.texthead}
        />
        <button
          onClick={() => navigate("/editProfile/EditBusinessInfo")}
          className={styles.edit_button}
        >
          <FiEdit className={styles.icon} />
          <TextComponent textClass={styles.button_text}>
            Edit Profile
          </TextComponent>
        </button>
      </div>

      <div style={{ margin: "10px" }}>
        <TextComponent
          text={"Service Details"}
          textClass={styles.textsubHead}
        />
      </div>

      <div className={styles.main_box}>
        <div className={styles.next_box}>
          <div className={styles.options_bar}>
            <div className={styles.options_inner_bar}></div>
          </div>
          <div className={styles.rightCont}>
            <List dataSource={data} renderItem={renderItem} />
          </div>
        </div>

        <div className={styles.next_box}>
          <div className={styles.options_bar}>
            <div className={styles.options_inner_bar}></div>
          </div>
          <div className={styles.rightCont}>
            <List dataSource={dataa} renderItem={renderItem} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInfo;
